module.exports = __webpack_public_path__ + "img/1-min.dd7c9c29.jpg";